@if (isElectron()) {
  <router-outlet />
} @else {
  <si-info-page
    icon="element-warning-filled"
    iconColor="status-danger"
    titleText="Gridscale X™ PSS®E Copilot"
    copyText="This application is not supported in a web browser. Please launch it using the provided desktop installer."
    instructions=""
  />
}
